export default __webpack_public_path__ + "static/media/price.5850deb1.svg";